import { COMPANY_LIMIT, DEFAULT_MANDATE, MAX_PER_COMPANY } from '../constants/conversation';

const clamp = (value, { min, max }, fallback) => Math.min(max, Math.max(min, Number(value) || fallback));
const inRange = (value, { min, max }) => Number.isInteger(value) && value >= min && value <= max;

/**
 * The limit chips as `PATCH …/mandate` accepts them: `roles` only in mode `roles`,
 * `maxPerCompany` only in mode `all` (the server derives what the other modes imply and
 * refuses any other key).
 *
 * @param {object} form - The chips' state
 * @returns {object}
 */
export function toMandatePayload(form) {
	const contacts = { mode: form.contactMode };
	if (form.contactMode === 'roles') contacts.roles = form.roles;
	if (form.contactMode === 'all') {
		contacts.maxPerCompany = clamp(form.maxPerCompany, MAX_PER_COMPANY, DEFAULT_MANDATE.contacts.maxPerCompany);
	}
	return {
		companyLimit: clamp(form.companyLimit, COMPANY_LIMIT, 1),
		contacts,
		contactData: form.contactMode === 'none' ? ['email'] : ['email', ...(form.phone ? ['phone'] : [])],
		mapsEnabled: Boolean(form.mapsEnabled),
		mapsNationwide: Boolean(form.mapsEnabled && form.mapsNationwide),
	};
}

/**
 * The chips' state from a run snapshot. The per-company cap is only the user's own choice in
 * mode `all`; every other mode shows the dialog's default so a switch to `all` starts there.
 *
 * @param {object|null|undefined} mandate - From the run snapshot
 * @returns {object}
 */
export function toMandateForm(mandate) {
	const base = mandate ?? DEFAULT_MANDATE;
	const contacts = base.contacts ?? DEFAULT_MANDATE.contacts;
	const ownCap = contacts.mode === 'all' && inRange(contacts.maxPerCompany, MAX_PER_COMPANY);
	return {
		companyLimit: base.companyLimit ?? DEFAULT_MANDATE.companyLimit,
		contactMode: contacts.mode ?? DEFAULT_MANDATE.contacts.mode,
		roles: contacts.roles?.length ? contacts.roles : DEFAULT_MANDATE.contacts.roles,
		maxPerCompany: ownCap ? contacts.maxPerCompany : DEFAULT_MANDATE.contacts.maxPerCompany,
		phone: Boolean(base.contactData?.includes('phone')),
		mapsEnabled: Boolean(base.mapsEnabled),
		mapsNationwide: Boolean(base.mapsNationwide),
	};
}
